import { ExpressionResolverFn } from "../../core/types";
import { ExpressionResolverError } from "../errors";

class RoleExpressionError extends ExpressionResolverError {
  constructor(message: string) {
    super(message);
    this.name = "RoleExpressionError";
  }
}

/**
 * The role resolver checks if the user has the allowed role(s).
 *
 * Usage:
 * {
 *   function: "role",
 *   params: {
 *     allow: {
 *       value: "admin"  // Single role
 *       // OR
 *       value: ["admin", "superadmin"]  // Multiple roles (any match)
 *     }
 *   }
 * }
 */
export const roleResolver: ExpressionResolverFn = (config) => {
  const { expression, externalResources } = config;
  const { params } = expression;

  if (!params) {
    throw RoleExpressionError.create("No parameters provided");
  }

  if (!params.allow || !("value" in params.allow)) {
    throw RoleExpressionError.create("Missing allow.value parameter");
  }

  const allowedRoles = Array.isArray(params.allow.value)
    ? params.allow.value
    : [params.allow.value];

  const userRoles = externalResources?.userRoles || [];

  return userRoles.some((userRole) => allowedRoles.includes(userRole));
};
